<template>
  <div>
    <Spinner v-if="loading" />
    <StaticDataTable class="static-table-list" v-show="!loading && !loadingError">
      <template v-slot:header>
        <tr>
          <th width="30%">Production Stage</th>
          <th width="70%">Production Stations</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="productionStage in productionStageList" :key="productionStage.id">
          <td class="font-weight-bold">
            {{productionStage.name}}
          </td>
          <td v-if="!editing">
            <template v-for="(station, stationIndex) of stationListForProductionStage(productionStage.id)">
              <span v-if="stationIndex > 0" :key="`station-sep-${station.id}`">, </span>
              <LinkProductionStation :key="station.id" :id="station.id" :name="station.name" />
            </template>
            <span v-if="stationListForProductionStage(productionStage.id).length == 0" class="font-italic text-muted">Default</span>
          </td>

          <td v-if="editing">
            <FormMultiSelect
              :value="convertListToIDs(stationListForProductionStage(productionStage.id))"
              :options="stationLookupForProductionStage(productionStage.id)"
              @input="updateStationListForProductionStage(productionStage.id, $event)"
              placeholder="Select station overrides" />
          </td>

        </tr>
      </template>
    </StaticDataTable>
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>


<script>
import _ from 'lodash'
import formMixin from '@/mixins/form'

export default {
  name: 'ProductionGlassStockRouteEditor',
  model: {
    event: 'update'
  },
  mixins: [formMixin],
  props: {
    editing: Boolean,
    stockId: Number,
    value: Object
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      productionStageList: [],
      productionStationList: [],
      stockProductionConfig: _.cloneDeep(this.$props.value || {})
    }
  },
  computed: {
    productionStageLookup() {
      return this.productionStageList.map(stage => {
        return {
          value: stage.id,
          name: stage.name,
          colour: stage.highlightColour
        }
      })
    },
    productionStationLookup() {
      return this.productionStationList.map(station => {
        return {
          value: station.id,
          name: station.name
        }
      })
    }
  },
  watch: {
    value: function() {
      this.$data.stockProductionConfig = _.cloneDeep(this.$props.value)
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true
      this.loadingError = ''

      Promise.all([
        this.$apiService.productionService.getProductionStageList(),
        this.$apiService.productionService.getProductionStationList()
      ])
      .then(results => {
        this.productionStageList = results[0].data.filter(stage => stage.isActive)
        this.productionStationList = results[1].data
      })
      .catch(err => {
        this.loadingError = 'Failed to load data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    stationLookupForProductionStage(productionStageId) {
      var stage = this.productionStageList.find(stage => stage.id == productionStageId)
      if(stage) {
        return stage.productionStations.map(station => {
          return {
            value: station.id,
            name: station.name
          }
        })
      }

      return []
    },

    stationListForProductionStage(productionStageId) {
      if(!this.stockProductionConfig || !this.stockProductionConfig.productionStationRouteList)
        return []

      return this.stockProductionConfig.productionStationRouteList
      .filter(configData => configData.productionStageId == productionStageId)
      .map(configData => {
        let stationInfo = this.productionStationList.find(station => station.id == configData.productionStationId)
        return {
          id: configData.productionStationId,
          value: configData.productionStationId,
          name: stationInfo ? stationInfo.name : ''
        }
      })
    },
    updateStationListForProductionStage(productionStageId, productionStationList) {
      if(!this.stockProductionConfig.productionStationRouteList)
        this.stockProductionConfig.productionStationRouteList = []

      // Clear out the stage settings
      this.stockProductionConfig.productionStationRouteList = this.stockProductionConfig.productionStationRouteList.filter(override => {
        return override.productionStageId != productionStageId
      })

      // Add the stations
      this.stockProductionConfig.productionStationRouteList = _.concat(this.stockProductionConfig.productionStationRouteList, productionStationList.map(stationId => {
        return {
          productionStationId: stationId,
          productionStageId: productionStageId,
          stockId: this.stockId
        }
      }))

      this.$emit('update', this.stockProductionConfig)
    },
  }


}
</script>